import { module as BaseModule } from 'modujs'
import { language } from '../utils/dom'
// import { load } from 'recaptcha-v3'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.submit = this.el.querySelector('[data-form-submit]')
    this.inputs = this.el.querySelectorAll('input, textarea')
    this.select = document.querySelector('[data-form-select]')
    this.options = this.select?.querySelectorAll('li')
    this.address = this.el.querySelector('[data-form-address]')
    this.error = this.el.querySelector('[data-form-error]')
    this.succeed = this.el.querySelector('[data-form-succeed]')
    this.antispam = this.el.querySelector('[data-form-antispam]')

    this.isSending = false
    this.isSent = false
    this.isSpam = false

    if (this.address && this.options.length > 0) {
      this.setAddress(this.options[0].textContent)
    }

    this.initEventListeners()
  }

  initEventListeners() {
    this.inputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.checkInput(input)
      })
    })

    this.el.addEventListener('submit', async (e) => {
      e.preventDefault()
      this.checkSpam()
      if (this.isSending || this.isSent || this.isSpam) return
      this.send()
    })

    this.options.forEach((option) => {
      option.addEventListener('click', () => {
        this.setAddress(option.textContent)
      })
    })
  }

  setAddress(address) {
    this.address.value = address.trim()
  }

  checkSpam() {
    if (this.antispam.value !== '') this.isSpam = true
  }

  checkInput(el) {
    let isValid = true

    if (el.tagName === 'TEXTAREA' && el.value.trim() === '') {
      el.value = '' // remove white spaces
      isValid = false
    }

    const type = el.getAttribute('type')
    if (
      (type === 'hidden' ||
        type === 'text' ||
        type === 'number' ||
        type === 'email') &&
      el.value.trim() === ''
    ) {
      el.value = '' // remove white spaces
      isValid = false
    }

    if (type === 'checkbox' && !input.checked) {
      isValid = false
    }

    if (type === 'file' && input.files.length === 0) {
      isValid = false
    }

    // additonal check for file, max 5MB  per file
    if (type === 'file' && input.files.length > 0) {
      const file = input.files[0]
      if (file.size > 5 * 1024 * 1024) {
        isValid = false

        this.error.classList.remove('hidden')
        this.succeed.classList.add('hidden')
        this.error.innerHTML = language(
          'The file must not exceed 5MB',
          'Le fichier ne doit pas dépasser 5MB'
        )
      }
    }

    if (el === this.antispam) {
      el.value === '' ? (isValid = true) : (isValid = false)
    }

    if (isValid) {
      el.classList.remove('--invalid')
    } else {
      el.classList.add('--invalid')
    }
  }

  success(message) {
    this.submit.innerHTML = language('Sent!', 'Envoyé!')
    this.error.classList.add('hidden')
    this.succeed.classList.remove('hidden')
    this.succeed.innerHTML = message
  }

  fail(message) {
    this.inputs.forEach((input) => {
      this.checkInput(input)
    })
    this.submit.innerHTML = language('Send', 'Envoyer')
    this.error.classList.remove('hidden')
    this.error.innerHTML = message
  }

  async send() {
    this.isSending = true
    this.error.classList.add('hidden')

    this.name = document.querySelector('#name')
    this.phone = document.querySelector('#phone')
    this.email = document.querySelector('#email')
    this.date = document.querySelector('#date')
    this.address = document.querySelector('#address')
    this.message = document.querySelector('#message')

    this.submit.innerHTML = language('Sending...', 'Envoi en cours...')

    this.nonce = ajaxObject.nonce

    const data = new FormData()

    data.append('action', 'contact')
    data.append('name', this.name.value)
    data.append('phone', this.phone.value)
    data.append('email', this.email.value)
    data.append('date', this.date.value)
    data.append('message', this.message.value)
    data.append('address', this.address.value)
    data.append('nonce', this.nonce)

    const self = this

    const xhr = new XMLHttpRequest()
    xhr.open('POST', ajaxObject.ajaxurl, true)

    xhr.onload = async function () {
      // console.log(this)

      const response = await JSON.parse(this.response)
      // console.log(response)

      const en = response.data.en
      const fr = response.data.fr

      const noticeMessage = language(en, fr)

      if (this.status >= 200 && this.status < 400) {
        self.success(noticeMessage)
        self.isSent = true
      } else {
        self.fail(noticeMessage)
        self.isSending = false
      }
    }
    xhr.send(data)
  }
}
